// extracted by mini-css-extract-plugin
export default {"card_wrapper":"availableSection_card_wrapper__SOUx5","category_name":"availableSection_category_name__HICHT"};